<template>
  <Fragment>
    <tr v-show="!model._isHidden && !model._isFolded" class="" :class="getRowClass()">
      <td v-if="checkboxColumn" class="tree-grid__body-cell tree-grid__body-cell--with-checkbox">
        <input v-model="model._isChecked" class="tree-grid__checkbox" type="checkbox" :indeterminate.prop="model._isIndeterminate" :disabled="model._isDisabled" @change="event => onCheckRow(event.target.checked)" />
      </td>
      <td v-for="(column, columnIndex) in columns" :key="columnIndex" class="tree-grid__body-cell">
        <template v-if="hasChildren && columnIndex === 0">
          <v-icon v-if="model._isExpanded" small :style="rowPreSpaceStyle(row, true)" @click="onExpand(false)">mdi-chevron-down</v-icon>
          <v-icon v-else small :style="rowPreSpaceStyle(row, true)" @click="onExpand(true)">mdi-chevron-right</v-icon>
        </template>
        <template v-else>
          <span v-if="columnIndex === 0" :style="rowPreSpaceStyle(row, false)"></span>
        </template>
        <slot :name="'cell.' + column.prop" v-bind:row="row">
          {{ row.hasOwnProperty(column.prop) ? row[column.prop] : '' }}
        </slot>
      </td>
    </tr>
    <template v-if="hasChildren">
      <TreeGridRow v-for="(childRow, index) in children" v-show="!model._isHidden && !model._isFolded" :key="index" :columns="columns" :row="childRow" :children-property="childrenProperty" :row-class="rowClass" @row-checked="onChildRowChecked" @row-expanded="onChildRowExpanded">
        <!--Modified.by.KWShin.2024.04.08.-->
        <!--template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope"-->
        <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
          <slot :name="slot" v-bind="scope" />
        </template>
      </TreeGridRow>
    </template>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';

export default {
  name: 'TreeGridRow',
  components: { Fragment },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    rowClass: {
      type: Function,
      default: () => '',
    },
    childrenProperty: {
      type: String,
      default: 'children',
    },
    checkboxColumn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: this.row,
    };
  },
  computed: {
    hasChildren() {
      return this.children.length > 0;
    },
    children() {
      return this.model[this.childrenProperty] || [];
    },
  },
  watch: {
    row: {
      handler(val) {
        this.model = val;
      },
      deep: true,
    },
  },
  methods: {
    onCheckRow(isChecked) {
      this.$emit('row-checked', this.model, isChecked);
    },
    onExpand(isExpanded) {
      this.$emit('row-expanded', this.model, isExpanded);
    },
    onChildRowChecked(childRow, isChecked) {
      this.$emit('row-checked', childRow, isChecked);
    },
    onChildRowExpanded(childRow, isExpanded) {
      this.$emit('row-expanded', childRow, isExpanded);
    },
    getRowClass() {
      const classNames = ['tree-grid__body-row', ['tree-grid__body-row--level-', this.model._level].join('')];

      if (this.model._isHidden) {
        classNames.push('tree-grid__body-row--hidden');
      }

      if (this.model._isFolded) {
        classNames.push('tree-grid__body-row--folded');
      }

      classNames.push(this.rowClass(this.model));

      return classNames.join(' ');
    },
    rowPreSpaceStyle(row, hasChildren) {
      const addSpace = hasChildren ? 0 : 1;
      return `margin-left: ${(parseInt(row._path.split('.').length / 2) + addSpace) * 18}px`;
    },
  },
};
</script>
